// extracted by mini-css-extract-plugin
export default {"header":"header_header__lOwdN","menu":"header_menu__7kbXF","menu_item":"header_menu_item__5-pFF"};